import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from "react-redux";
import { FaHome } from "react-icons/fa";
import {NavItem} from "react-bootstrap";

function Navigation() {
    const userGroups = useSelector(state => state.authentication.userGroups);
    const selectedRole = useSelector(state => state.authentication.selectedRole);

    return (
        <div className="navigation">
            {!userGroups.length && (
                <NavItem className="nav-link">
                    <Link to="/"><FaHome /></Link>
                </NavItem>
            )}
            {selectedRole === "" && (
                <NavItem>
                    {userGroups.includes('staffmembers') && <Link to="/mdb/staff"><FaHome /></Link>}
                    {userGroups.includes('humanressource') && <Link to="/mdb/hr"><FaHome /></Link>}
                    {userGroups.includes('institute') && <Link to="/mdb/institute"><FaHome /></Link>}
                    {userGroups.includes('rectorate') && <Link to="/mdb/rectorate"><FaHome /></Link>}
                    {userGroups.includes('admin') && <Link to="/mdb/admin"><FaHome /></Link>}
                    {userGroups.includes('school') && <Link to="/mdb/school"><FaHome /></Link>}
                </NavItem>
            )}
            {selectedRole !== "" && (
                <NavItem>
                    {selectedRole === 'staffmembers' && <Link to="/mdb/staff"><FaHome /></Link>}
                    {selectedRole === 'humanressource' && <Link to="/mdb/hr"><FaHome /></Link>}
                    {selectedRole === 'institute' && <Link to="/mdb/institute"><FaHome /></Link>}
                    {selectedRole === 'rectorate' && <Link to="/mdb/rectorate"><FaHome /></Link>}
                    {selectedRole === 'admin' && <Link to="/mdb/admin"><FaHome /></Link>}
                    {selectedRole === 'school' && <Link to="/mdb/school"><FaHome /></Link>}
                </NavItem>
            )}
        </div>
    );
}

export default Navigation;
